angular.module('siter.io').directive 'access', ["$timeout", "$rootScope", ($timeout, $rootScope) ->
  {
    restrict: 'A'
    prioriry: 100000
    scope: false
    link: ->
      return
    compile: (element, attr, linker) ->
      accessDenied = true
      accessElement = attr.accessElement

      user = window.justclick.currentUser
      attributes = attr.access.split(' ')
      for i of attributes
        if user.role == attributes[i]
          accessDenied = false
      if accessDenied
        if accessElement
          element.css('display', 'none')
        $timeout ->
          $("[access='#{attr.access}']").remove()

      return
  }
]



// WEBPACK FOOTER //
// ./src/app/common/directives/access.coffee